import $ from "jquery";
import jQueryBridget from "jquery-bridget";
import Isotope from "isotope-layout";

export const teamFiltering = () => {
  // make Isotope a jQuery plugin
  jQueryBridget("isotope", Isotope, $);

  // Find the filter value of the active button
  const activeFilter = $(".filter-button-group .active").attr("data-filter");

  // Initialize Isotope with the filter of the active button
  const $grid = $(".grid").isotope({
    filter: activeFilter,
  });

  $(".filter-button-group").on("click", "button", function () {
    const filterValue = $(this).attr("data-filter");
    const $parent = $(this).parents(".layout.team-cards");

    $parent.find(".filter-button-group button").removeClass("active");
    $(this).addClass("active");

    $parent.find(".cat-description").removeClass("active");
    $parent
      .find(`.cat-description[data-id="${filterValue}"]`)
      .addClass("active");

    $grid.isotope({
      filter: filterValue,
    });

    /** Mobile carousel wrapper filtering */
    $parent.find(`.team-carousel`).removeClass("active");
    $parent.find(`.team-carousel[data-id="${filterValue}"]`).addClass("active");
  });
};
